import { render } from "./ProductDetailsPage.vue?vue&type=template&id=617009ae"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__